module.exports = __webpack_public_path__ + "img/spartan-sheetrock-framing-texture-03-tablet.1215aa36.jpg";